import { applicationKeys, IApplicationKeyParams } from './applicationKeys';

export interface IApplicationAssignmentKeyParams extends IApplicationKeyParams {
  marketCountry: string;
}

export const applicationAssignmentKeys = {
  root: (params: IApplicationAssignmentKeyParams) =>
    [
      ...applicationKeys.root(params),
      params.marketCountry,
      'assignment',
    ] as const,
};

export function parseApplicationAssignmentKey<
  T extends keyof typeof applicationAssignmentKeys
>(
  queryKey: ReturnType<(typeof applicationAssignmentKeys)[T]>
): IApplicationAssignmentKeyParams {
  const [, applicationID, marketCountry] = queryKey;

  return { applicationID, marketCountry };
}
